<template>
<div>
    <base-header v-once pageName="QR 인증" :prevBtnShow="true" history="main"></base-header>
    
        <section id="wrap">
        <div class="qrWrap">
            <p>
                <span class="promotion"  v-if="promotionInfo.sqno > 0" @click="showPromotion" >프로모션 보기</span>
            </p>
            <div>
                <span>QR코드 찍고!<br/>관심고객 간편 등록해보세요!</span>
                <figure> 
                    <qrcode-vue :value="value" level="H" />
                </figure>
            </div>
            <button type="button" class="reg" @click="myCstmrReg()">고객등록 바로가기</button>
            <button type="button" class="list" @click="notificationSet()">설정 바로가기</button>
        </div>
    </section>
</div>
</template>

<script>
var QrcodeVue = () => import('qrcode.vue');
export default {
  name: "qr",
  components: {
    QrcodeVue
  },
  data() {
      return{
        value: '',
        size: 210,
        promotionInfo: {
            sqno:0
        },
      };
  },

  mounted: function() {
      this.base();
  },

  methods: {

    base: function(){ // 현재 서버 url 및 로그인 userId 조회
        var that = this;
        this.$api.myCstmr.base()
            .then(function(res) {
                that.value = 'http://ksos.kyowon.co.kr/smplJoin/eduKakaoSync?akdcde=' + res.loginUserid; 
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
    },
    getPromotionInfo: function(){ //프로모션 정보
        var that = this;
        this.$api.eduplan.base().then(function(data) {
            if(data.promotionInfo){     
                that.promotionInfo = data.promotionInfo;
            }
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
    },
    myCstmrReg:function () {
        this.$router.push('/myCstmr/myCstmrReg'); 
    },
     notificationSet: function() {
        this.$utils.nativeIf.outbound.newPage("/set/notificationSet")  //새창 띄우기
    },
    showPromotion:function(){
        this.$utils.nativeIf.outbound.newPage('/eduplanmap/promotion?sqno='+this.promotionInfo.sqno);
    },
  },
  created: function() { 
    this.getPromotionInfo();
  },
};
</script>
